import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { version } from '../../core/version';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: 'https://c3b53246507844e1b8414146b42d7932@o1152704.ingest.us.sentry.io/5823500',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.captureConsoleIntegration({
      // To debug local (#1), apply desired log levels.
      levels: environment.environmentLabel === 'local' ? [] : ['error', 'warn'], // In case we turn Sentry on for local...
    }),
  ],
  release: `${version.current}`,
  environment: environment.environmentLabel,
  // Set tracesSampleRate to 1.0 to capture 100% in dev, 20% in prod.
  tracesSampleRate: environment.production ? 0.2 : 1.0,
  beforeSend: (event) => {
    // Filter out unwanted events going to Sentry.
    if (
      event?.message?.includes('exceeds maximum size of 256.0K') ||
      event?.message?.includes('Failed to poll for updated messages.') ||
      event?.message?.includes('Failed to poll for unread messages.') ||
      event?.message?.includes('Failed to poll for recent messages.')
    ) {
      return null;
    }

    return event;
  },
});

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.log(err));
